import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, ListGroup } from 'react-bootstrap';

const RmSiteListModal = ({ show, onHide, uniqueData, onSiteSelect }) => {
    const [searchTerm, setSearchTerm] = useState("");

    const handleSiteSelect = (site) => {
        onSiteSelect(site);
    };

    const handelSearchInputChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const SearchedListofsites = uniqueData && uniqueData.length > 0
        ? uniqueData.filter((options) => {
            if (options.site && options.site.trim() !== '') {
                return options.site.toLowerCase().includes(searchTerm.toLowerCase());
            }
            return false;
        })
        : [];

    return (
        <Modal className="gigpigmodal justify-content-center" show={show} onHide={onHide}>
            <Modal.Header closeButton closeVariant='white'>
                <Modal.Title>Select a Site</Modal.Title>
            </Modal.Header>
            <Modal.Body className="GipPig-Modal">
                <div className="search-bar-container">
                    <input
                        type="text"
                        placeholder="Search for site..."
                        value={searchTerm}
                        className="search-input"
                        onChange={handelSearchInputChange}
                    />
                </div>
                <div className="list-container">
                    <ListGroup style={{ width: '100%' }}>
                        {SearchedListofsites.map((site, index) => (
                            <ListGroup.Item key={index} action onClick={() => handleSiteSelect(site)}>
                                {site.site}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </div>
            </Modal.Body>
        </Modal>
    );
};

RmSiteListModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    uniqueData: PropTypes.array.isRequired,
    onSiteSelect: PropTypes.func.isRequired,
};

export default RmSiteListModal;
